module.exports = __webpack_public_path__ + "static/img/44.fded763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pousada/44.jpg
// module id = R26H
// module chunks = 1